import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_rs32gqhrfb: FaireCollectionEntity = {
  token: "pbc_rs32gqhrfb",
  type: "collection",
  name: "Pre-Order FW26 Joyful Days - Organic Sweater Knits",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b876049004e516187b39c778f84be1993429dce1384f71775b6c4bd5f6e072fb.png",
  itemCount: 29,
  description:
    "Our FW26 baby knitwear collection is designed to celebrate warmth, comfort, and the simple pleasures of everyday moments. Thoughtfully crafted from 100% certified organic cotton, these heirloom-inspired knits blend timeless design with playful charm—perfect for cozy days.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:15.637Z",
    importedBy: "entity-db-import-collections",
  },
};
